'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultConfigs = exports.defaultConfigs = {
  TEST: {
    appId: 'Hudl',
    collectorEndpoint: 'jnl7d8fsqlfo91xd.thorhudl.com',
    cookieDomain: '.thorhudl.com',
    discoverRootDomain: false,
    encodeBase64: true,
    forceSecureTracker: true,
    platform: 'web',
    post: true,
    stateStorageStrategy: 'localStorage',
    userFingerprint: true,
    contexts: {
      webPage: true,
      gaCookies: true,
      geolocation: false,
      performanceTiming: true
    }
  },
  PROD: {
    appId: 'Hudl',
    collectorEndpoint: 'jnl7d8fsqlfo91xd.hudl.com',
    cookieDomain: '.hudl.com',
    discoverRootDomain: false,
    encodeBase64: true,
    forceSecureTracker: true,
    platform: 'web',
    post: true,
    stateStorageStrategy: 'localStorage',
    userFingerprint: true,
    contexts: {
      webPage: true,
      gaCookies: false,
      geolocation: false,
      performanceTiming: false
    }
  }
};